import styled from "@emotion/styled";
import { ArrowDownIcon } from "@smartsheet/lodestar-icons";
import { ChevronDownIcon } from "@smartsheet/ursa-icons";
import React from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { selectV2Theme } from "../selectV2Theme";
const ToggleButtonLodestar = styled(ArrowDownIcon)`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    position: relative;
    top: -2px;
    left: -2px;
`;
const ToggleButtonWrapper = styled("span")`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    // margin: -4px;
    height: ${_ref => {
  let {
    themeMode
  } = _ref;
  return selectV2Theme.actionButtons.buttonWrapperSize(themeMode);
}};
    width: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return selectV2Theme.actionButtons.buttonWrapperSize(themeMode);
}};
`;
export const ToggleButtonIcon = () => {
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(ToggleButtonWrapper, {
    themeMode: themeMode
  }, (() => {
    if (themeMode.includes("ursa")) {
      return /*#__PURE__*/React.createElement(ChevronDownIcon, {
        size: 16
      });
    } else {
      return /*#__PURE__*/React.createElement(ToggleButtonLodestar, null);
    }
  })());
};
//# sourceMappingURL=ToggleButtonIcon.js.map